/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const UPDATE_TENANT_ARRAY_SETTINGS = gql`
  mutation UpdateTenantArraySettings($data: ArraySettingsInput!) {
    updateTenantArraySettings(data: $data) {
      insideSalesCategories
      outsideSalesCategories
      fuelSalesCategories
    }
  }
`
